import { render, staticRenderFns } from "./Egs.vue?vue&type=template&id=fd5b993a"
import script from "./Egs.vue?vue&type=script&lang=js"
export * from "./Egs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports